import axios from 'axios';
import { API, ApiKey } from '../config';
const headerAPI = { ApiKey: `${ApiKey}`};

export const getIngredient = (id) => {
  return axios.get(`${API}/api/ingredients/${id}`, { headers: headerAPI });
};
